import React from "react";
import styled, { css, keyframes } from "styled-components";

export default function AssistantChat({ assistantLogo, content, loading }) {
  const renderAssistantChat = () => {
    return (
      <Container>
        <Header>
          <AssistantAuthorContainer>{assistantLogo}</AssistantAuthorContainer>
          <Assistant>ASSISTANT</Assistant>
        </Header>
        <Content loading={loading}>{content}</Content>
      </Container>
    );
  };

  return renderAssistantChat();
}

AssistantChat.propTypes = {};

AssistantChat.defaultProps = {};

const Container = styled.div`
  & {
    width: 100%;
    padding: 1rem 1.5rem;
    background-color: #f7f7f8;
    border-bottom: 1px solid #dbdbdb;
  }
`;

const Header = styled.div`
  & {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-bottom: 0.5rem;
  }
`;

const AssistantAuthorContainer = styled.div`
  & {
    height: 20px;
    width: 20px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) =>
      props.themeColor || props.theme.palette.primary.main};
  }
`;

const Assistant = styled.div`
  & {
    fontsize: 11px;
    text-transform: uppercase;
    color: ${(props) => props.themeColor || props.theme.palette.primary.main};
  }
`;

const blinking = keyframes`
  0% {
    opacity: 0;
  }
`;

const chatContentCss = css`
  color: #434343;
`;

const blinkingCss = css`
  font-size: 16px;
  animation: ${blinking} 1s steps(2) infinite;
  content: "▋";
  vertical-align: baseline;
  margin-left: 0.25rem;
`;

const Content = styled.div`
  & {
    width: 100%;
    white-space: pre-wrap;
    font-size: 14px;
    ${(props) => (props.loading ? null : chatContentCss)}
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: gray;
    border-radius: 4px;
  }

  &:after {
    ${(props) => (props.loading ? blinkingCss : null)}
  }
`;
